import { useState } from "react";
import axios from "axios";
import { Upload, Send, FileText, User, Tag, Layers, X } from "lucide-react"; 
import "./AddMemoire.css"; // Réutilise le même CSS

export default function AddMemoireNonM() {
  const [form, setForm] = useState({
    intitule_M: "", 
    intitule_R: "", 
    Ecrivain: "",
    resume_M: "", 
    resume_R: "", 
    mots_cles: "", 
    Axes: ""
  });

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));
    if (image) formData.append("Couverture_R", image);

    try {
      const token = localStorage.getItem("token");

      
      const res = await axios.post("https://api.memofacdz.com/api/memoires-non-mentionnes", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });

      alert("Mémoire non mentionné enregistré ! ✨");
      // Réinitialisation
      setForm({ intitule_M: "", intitule_R: "", Ecrivain: "", resume_M: "", resume_R: "", mots_cles: "", Axes: "" });
      setPreview(null);
      setImage(null);
    } catch (err) {
      alert(err.response?.data?.message || "Erreur lors de l'envoi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-main">
      <div className="card">
        <div className="header">
          <h1>Nouveau Mémoire (Non Mentionné)</h1>
          <p>Enregistrement dans la collection hors mention</p>
        </div>

        <form onSubmit={handleSubmit} className="form-grid">
          <div className="form-column">
            <div className="input-group">
              <label>intitulé memoire</label>
              <div className="input-wrapper">
                <FileText className="icon" size={18} />
                <input name="intitule_M" value={form.intitule_M} placeholder="Ex: Étude sur..." onChange={handleChange} required />
              </div>
            </div>

            <div className="input-group">
              <label>Auteur</label>
              <div className="input-wrapper">
                <User className="icon" size={18} />
                <input name="Ecrivain" value={form.Ecrivain} placeholder="Nom complet" onChange={handleChange} required />
              </div>
            </div>

            <textarea name="resume_M" value={form.resume_M} className="textarea-field" placeholder="Problématique" onChange={handleChange}></textarea>
            <textarea name="resume_R" value={form.resume_R} className="textarea-field" placeholder="Résumé Roman" onChange={handleChange}></textarea>
          </div>

          <div className="form-column">
             <div className="input-group">
              <label>Intitulé Roman</label>
              <div className="input-wrapper">
                <FileText className="icon" size={18} />
                <input name="intitule_R" value={form.intitule_R} placeholder="Ex : Zelda...." onChange={handleChange} />
              </div>
            </div>

            <div className="input-group">
              <label>Métadonnées</label>
              <div className="input-wrapper" style={{marginBottom: '10px'}}>
                <Tag className="icon" size={18} style={{color: '#4f46e5'}} />
                <input name="mots_cles" value={form.mots_cles} placeholder="Mots-clés" onChange={handleChange} />
              </div>
              <div className="input-wrapper">
                <Layers className="icon" size={18} style={{color: '#4f46e5'}} />
                <input name="Axes" value={form.Axes} placeholder="Axes de recherche" onChange={handleChange} />
              </div>
            </div>

            <div className="upload-container">
              <div className="upload-zone" onClick={() => !preview && document.getElementById('fileInput').click()}>
                {preview ? (
                  <div style={{position: 'relative'}}>
                    <img src={preview} alt="Preview" className="preview-img" />
                    <button type="button" className="remove-btn" onClick={(e) => { e.stopPropagation(); setPreview(null); setImage(null); }} style={{position: 'absolute', top: 0, right: '25%', background: '#ef4444', color: 'white', border: 'none', borderRadius: '50%', padding: '5px'}}>
                      <X size={14} />
                    </button>
                  </div>
                ) : (
                  <>
                    <Upload className="icon" size={32} />
                    <p style={{fontSize: '13px'}}>Uploader la couverture</p>
                  </>
                )}
                <input id="fileInput" type="file" accept="image/*" onChange={handleFile} style={{display: 'none'}} />
              </div>
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? "Envoi..." : <><Send size={18} /> Enregistrer</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}